import React, { useState } from 'react';

import styled from '@emotion/styled';

import { Modal } from '@shared/components/bootstrap';

import { client } from '@admin/libraries/apollo';
import { PlanKindEnum, PlanTypeEnum, useAccountStorageLadderQuery } from '@admin/schema';

import { StoragePricingTable } from './storage_pricing_table';

const PricingModal: React.FC<{
  accountID: string;
  onClose(): void;
}> = ({ accountID, onClose }) => {
  const { data } = useAccountStorageLadderQuery({ variables: { accountID }, client });

  if (!data) {
    return null;
  }

  const {
    account: { subscriptions, storageLadderPricings },
  } = data;
  const storageSubscriptions = subscriptions.filter(
    (subscription) => subscription.pricing.plan.type === PlanTypeEnum.StoragePlan,
  );
  const selectedSubscription = storageSubscriptions[0];
  const isCustom = selectedSubscription ? selectedSubscription.pricing.plan.kind === PlanKindEnum.Custom : false;

  let title = 'Pricing';
  if (isCustom) {
    title += ' (Custom)';
  }

  return (
    <Modal onClose={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StoragePricingTable
            isCustom={isCustom}
            selectedSubscription={selectedSubscription}
            storageLadderPricings={storageLadderPricings}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

const TextLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

export const StorageLadderModal: React.FC<{ accountID: string }> = ({ accountID }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <TextLink onClick={() => setShowModal(true)}>See other plans / pricing</TextLink>
      {showModal && <PricingModal accountID={accountID} onClose={() => setShowModal(false)} />}
    </>
  );
};
